import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { AuthStatusEnum, useAuth } from '@sola/auth-sdk/store.tsx';
import { getPublicConfig } from '@sola/config/lib/getters.ts';
import { trackClick } from '@sola/tracking/components/datalayer.tsx';
export interface MobileAccountItem {
  id: string;
  label: string;
  action: () => void;
}
export const useNavStackMobileAccount = () => {
  const $ = _c(29);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getPublicConfig();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    NEXT_PUBLIC_BASE_URL_MYACCOUNT
  } = t0;
  const {
    actions: authActions
  } = useAuth("actions");
  const {
    currentStatus: currentAuthStatus
  } = useAuth("currentStatus");
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    t
  } = useTranslation(t1);
  const router = useRouter();
  let t2;
  if ($[2] !== authActions || $[3] !== t) {
    t2 = () => {
      trackClick(t("priority:nav.logOut"));
      authActions.logOut();
    };
    $[2] = authActions;
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const logOut = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("priority:header.myAccount");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== router) {
    t4 = () => router.push(NEXT_PUBLIC_BASE_URL_MYACCOUNT);
    $[7] = router;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = {
      id: "myAccount",
      label: t3,
      action: t4,
      condition: !!NEXT_PUBLIC_BASE_URL_MYACCOUNT
    };
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("priority:nav.logOut");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = currentAuthStatus === AuthStatusEnum.Authenticated;
  let t8;
  if ($[14] !== logOut || $[15] !== t6 || $[16] !== t7) {
    t8 = {
      id: "logOut",
      label: t6,
      action: logOut,
      condition: t7
    };
    $[14] = logOut;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("priority:header.contactUs");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== router) {
    t10 = () => router.push("/about-us/contact");
    $[20] = router;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = {
      id: "contactUs",
      label: t9,
      action: t10
    };
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t11 || $[26] !== t5 || $[27] !== t8) {
    const mobileAccountItems = [t5, t8, t11].filter(_temp).map(_temp2);
    t12 = {
      mobileAccountItems
    };
    $[25] = t11;
    $[26] = t5;
    $[27] = t8;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
function _temp(item) {
  return !("condition" in item) || item.condition;
}
function _temp2(t0) {
  const {
    id,
    label,
    action
  } = t0;
  return {
    id,
    label,
    action
  };
}